export default __webpack_public_path__ + "static/leftImg-582b20c27bceac5709e2f21eb7d7da9d.png";